type CleverBoot = { csrf?: string };
type CleverWindow = Window & { __CLEVER__?: CleverBoot };

export function pickCsrf(bootstrap: string | undefined, stored: string | null): string {
  return stored || bootstrap || "";
}

export function rememberCsrf(csrf: string, boot: CleverBoot | undefined, storage: Pick<Storage, "setItem">): CleverBoot {
  storage.setItem("clever_csrf", csrf);
  return { ...boot, csrf };
}

function readCsrf(): string {
  const boot = (window as CleverWindow).__CLEVER__?.csrf;
  return pickCsrf(boot, sessionStorage.getItem("clever_csrf"));
}

function storeCsrf(csrf: string) {
  const w = window as CleverWindow;
  w.__CLEVER__ = rememberCsrf(csrf, w.__CLEVER__, sessionStorage);
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const csrf = readCsrf();
  const headers = new Headers(init.headers);
  if (init.method && init.method !== "GET") {
    headers.set("content-type", headers.get("content-type") || "application/json");
    headers.set("x-csrf-token", csrf);
    headers.set("x-requested-with", "Clever");
  }
  const res = await fetch(path, { ...init, headers, credentials: "same-origin" });
  const data = await res.json().catch(() => ({}));
  if (res.ok && data && typeof data === "object" && "csrf" in data && (data as { csrf?: unknown }).csrf) {
    storeCsrf(String((data as { csrf: string }).csrf));
  }
  if (!res.ok) {
    const err = new Error((data as { detail?: string }).detail || "request failed") as Error & { status: number; body: unknown };
    err.status = res.status;
    err.body = data;
    throw err;
  }
  return data as T;
}
